import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ExternalBuyerMappingsApi } from '../api/external-buyer-mappings.api';
import { UploadMappingsResponseDto } from '../api/dtos/external-buyer-mappings.dto';

@Injectable({ providedIn: 'root' })
export class ExternalBuyerMappingsService {
  private readonly _api = inject(ExternalBuyerMappingsApi);

  public uploadMappings(
    file: File,
    buyerId: string,
    buyerKey: string,
  ): Observable<UploadMappingsResponseDto> {
    return this._api.uploadMappings(file, buyerId, buyerKey);
  }

  public downloadMappings(id: string): Observable<Blob> {
    return this._api.downloadMappings(id);
  }
}
